import React from 'react';
import './PatternSelector.css';
import { getCompatiblePatterns } from '../config/patterns';
import PatternIcon from './PatternIcon';

const PatternSelector = ({ selectedPattern, onPatternChange, disabled, boardSize = 8 }) => {
  // Get patterns compatible with current board size
  const compatiblePatterns = getCompatiblePatterns(boardSize);

  // Sort patterns by number of tiles (pieces) and then by name
  const sortedPatterns = [...compatiblePatterns].sort((a, b) => {
    // Get the number of tiles for each pattern
    const getTileCount = (patternId) => {
      const patternConfig = {
        'tic': 3,
        'skinny': 4,
        'el': 3,
        'boxy': 4,
        'elly': 4,
        'knobby': 4,
        'tippy': 4,
        'snaky': 6,
        'aspy': 5,
        'cross': 5,
        'tee': 5,
        'f': 5,
        'stair': 5,
        'p': 5,
        'l': 5,
        'y': 6,
        'u': 5,
        'c': 6,
        's': 6,
        'i': 5
      };
      return patternConfig[patternId] || 0;
    };

    const aTiles = getTileCount(a.id);
    const bTiles = getTileCount(b.id);

    // First sort by number of tiles
    if (aTiles !== bTiles) {
      return aTiles - bTiles;
    }

    // Then sort by name
    return a.name.localeCompare(b.name);
  });

  const handlePatternClick = (patternId) => {
    if (!disabled) {
      onPatternChange(patternId);
    }
  };

  return (
    <div className="pattern-selector">
      {/* Visual Pattern Grid */}
      <div className="pattern-selector-grid">
        {sortedPatterns.map((pattern) => (
          <div
            key={pattern.id}
            className={`pattern-grid-item ${selectedPattern === pattern.id ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
            onClick={() => handlePatternClick(pattern.id)}
          >
            <div className="pattern-visual">
              <PatternIcon patternId={pattern.id} size="small" />
            </div>
            <div className="pattern-label">
              <div className="pattern-name">{pattern.name}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PatternSelector;
